import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "../../components/shared/layout"
import SEO from "../../components/SEO/SEO"
import styled from "@emotion/styled"
import {
  color,
  wrapper,
  breakpoints,
  ContentStyles,
  ContentStylesExt,
  wrapper1200,
} from "../../utils/style"
import Img from "gatsby-image"
import Breadcrumbs from "../../components/shared/Breadcrumbs"
import PromoBlock from "../../components/Content/PromoBlock"
import GameProvidersNew from "../../components/Content/GameProvidersNew"
import ContactBlock from "../../components/Content/ContactBlock"
import MainSlider from "../../components/Content/MainSlider"
import Squares from "../../icons/svg/Squares"
import Subcategories from "../../components/Content/Blog/Subcategories"
import { navigate } from "@reach/router"

const WrapperDesktop = styled("div")`
  ${wrapper1200};
  h1 {
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      margin-right: 10px;
    }
  }
`

const ContentWrapper = styled("div")`
  ${wrapper};
  ${ContentStyles};
  ${ContentStylesExt};
`

const PostContentWrapper = styled("div")`
  margin: 20px 0;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  a {
    display: flex;
    flex-basis: 49%;
    position: relative;
    margin: 10px 0;
    overflow: hidden;

    .image-wrap {
      flex-basis: 40%;
    }

    .text-part {
      flex-basis: 60%;
      padding: 0 20px;
    }

    .h5 {
      display: block;
      margin: 0;
      font-size: 18px;
      line-height: 24px;
      color: ${color.white};
    }

    .button {
      margin-top: 8px;
    }

    &:hover,
    &:active {
      text-decoration: none;
      color: ${color.white};
    }
    .gatsby-image-wrapper {
      height: 100%;
    }
    .tags {
      margin: 3px 0;
      p {
        color: ${color.gold};
      }
      span {
        color: ${color.white};
      }
      .tag {
        display: inline-block;
        font-size: 14px;
        line-height: 24px;
        position: initial;
        margin: 0;
        padding: 0;
        color: ${color.gold};
        background: inherit;
        border: none;
        cursor: pointer;
        &:hover {
          color: ${color.white};
        }
      }
    }
  }

  @media (max-width: ${breakpoints.md}) {
    a {
      flex-basis: 100%;
    }
  }

  @media (max-width: ${breakpoints.sm}) {
    width: 100%;
    a {
      display: block;
      .text-part {
        padding: 16px 0;
      }
      .button {
        width: 100%;
      }
    }
  }
`

const NavLink = props => {
  if (!props.test) {
    return (
      <Link
        aria-label={"page " + props.text}
        className={`pagination ${props.className}`}
        key={"link" + 1 + Math.random() * 100}
        to={props.url}
      >
        {props.text}
      </Link>
    )
  } else {
    return (
      <span
        key={"span" + 1 + Math.random() * 100}
        className="pagination pagination-span"
      >
        {props.text}
      </span>
    )
  }
}

const PaginationHolder = styled("div")`
  flex-basis: 100%;
  margin-top: 50px;
  padding: 10px;
  text-align: center;
  margin-bottom: 20px;
  div,
  a,
  span {
    display: inline-block;
    vertical-align: top;
  }

  .pagination {
    margin: 3px;
    padding: 5px 7px;
    background-color: transparent;
    border: 2px solid ${color.white};
    border-radius: 4px;
    color: ${color.white};
    width: 38px;
    height: 38px;
    text-align: center;
    &.last-active {
      margin-right: 30px;
      position: relative;
      &:after {
        content: "...";
        font-size: 40px;
        line-height: 1;
        position: absolute;
        bottom: 0;
        right: -30px;
      }
    }
  }
  .pagination:hover,
  .pagination:active,
  .pagination-span {
    background-color: ${color.gold};
    color: ${color.white};
    border-color: ${color.gold};
    text-decoration: none;
  }

  .previousLink .pagination,
  .nextLink .pagination {
    height: 38px;
    width: 100px;
    position: relative;
    display: inline-block;
  }
  .previousLink .pagination::before {
    content: "";
    position: absolute;
    left: 0;
    top: 9px;
    width: 0;
    height: 0;
    border: 8px solid transparent;
    border-right-color: ${color.white};
  }
  .nextLink .pagination::before {
    content: "";
    position: absolute;
    top: 9px;
    right: 0;
    width: 0;
    height: 0;
    border: 8px solid transparent;
    border-left-color: ${color.white};
  }
`

const PaginatedPage = ({ data, pageContext }) => {
  const {
    group,
    index,
    first,
    last,
    pageCount,
    additionalContext,
  } = pageContext
  const checkIsCurrent = (edge, id) => {
    return edge.node.id === id
  }

  const currentCategoryArr = data.allWordpressCategory.edges.filter(edge =>
    checkIsCurrent(edge, additionalContext.id)
  )
  const currentCategory = currentCategoryArr[0].node
  const metaTitle =
    currentCategory.yoast_meta && currentCategory.yoast_meta.yoast_wpseo_title
      ? currentCategory.yoast_meta.yoast_wpseo_title
      : currentCategory.title + "- " + process.env.OWNER
  const metaDesc =
    currentCategory.yoast_meta &&
    currentCategory.yoast_meta.yoast_wpseo_metadesc
      ? currentCategory.yoast_meta.yoast_wpseo_metadesc
      : ""
  const breadcrumbs = pageContext.breadcrumbs
  const page_title = pageContext.page_title
  const previousUrl = index - 1 === 1 ? "" : (index - 1).toString()
  const nextUrl = (index + 1).toString()
  const submenuLinkTitle =
    currentCategory.wordpress_id === 51 ? "ทั้งหมด" : currentCategory.name

  const clearedPath = currentCategory.path.replace("category/", "")

  const createPagination = (pagecount, index) => {
    let pages = []
    for (let i = 1; i <= pagecount; i++) {
      let page
      if (i === 1) {
        page = (
          <NavLink
            key={"blogUrl" + i + Math.random() * 100}
            index={i}
            test={index === i}
            className="blogUrl"
            url={clearedPath}
            text={i}
          />
        )
      }
      if (pagecount >= 5) {
        if (i >= 2 && i <= 3 && index < 3) {
          page = (
            <NavLink
              key={"blogUrl" + i + Math.random() * 100}
              index={i}
              test={index === i}
              className={`blogUrl ${
                i === 3 && index !== 3 ? "last-active" : ""
              }`}
              url={clearedPath + i + "/"}
              text={i}
            />
          )
        }
        if (i >= 2 && i <= 6 && index >= 3) {
          page = (
            <NavLink
              key={"blogUrl" + i + Math.random() * 100}
              index={i}
              test={index === i}
              className={`blogUrl ${
                i === 6 && index !== 6 ? "last-active" : ""
              }`}
              url={clearedPath + i + "/"}
              text={i}
            />
          )
        }
        if (index === 6) {
          page = (
            <NavLink
              key={"blogUrl" + i + Math.random() * 100}
              index={i}
              test={index === i}
              className={`blogUrl`}
              url={clearedPath + i + "/"}
              text={i}
            />
          )
        }
        if (i === pageCount) {
          page = (
            <NavLink
              key={"blogUrl" + i + Math.random() * 100}
              index={i}
              test={index === i}
              className="blogUrl"
              url={clearedPath + i + "/"}
              text={i}
            />
          )
        }
      } else {
        if (i === 1) {
          page = (
            <NavLink
              key={"blogUrl" + i}
              index={i}
              test={index === i}
              className="blogUrl"
              url={clearedPath}
              text={i}
            />
          )
        } else {
          page = (
            <NavLink
              key={"blogUrl" + i}
              index={i}
              test={index === i}
              className="blogUrl"
              url={clearedPath + i + "/"}
              text={i}
            />
          )
        }
      }
      pages.push(page)
    }
    return pages
  }

  const handleClick = (e, tag_url) => {
    e.preventDefault()
    navigate(tag_url)
  }

  return (
    <Layout>
      <SEO
        title={metaTitle}
        description={metaDesc}
        pathname={currentCategory.path.replace("category/", "")}
        key="seo"
        breadcrumbs={breadcrumbs}
      />
      <WrapperDesktop>
        <Breadcrumbs breadcrumbs={breadcrumbs} page_title={page_title} />

        <MainSlider />

        <ContactBlock />

        <div className="title-wrap">
          <h1 className="h1 rich-design with-icon a-center">
            <Squares />
            <span>{currentCategory.name}</span>
          </h1>
        </div>

        {(currentCategory.wordpress_id === 51 ||
          currentCategory.path.indexOf("blog")) > 0 && (
          <Subcategories title={submenuLinkTitle} />
        )}

        <PostContentWrapper key="content">
          {group.map(({ node }, index) => {
            return (
              <Link
                key={index + Math.random() * 100}
                to={"/" + node.slug + "/"}
              >
                <div className="image-wrap">
                  {node.featured_media &&
                  node.featured_media.localFile &&
                  node.featured_media.localFile.childImageSharp &&
                  node.featured_media.localFile.childImageSharp.fluid ? (
                    <Img
                      fluid={
                        node.featured_media.localFile.childImageSharp.fluid
                      }
                      alt={
                        node.featured_media.alt_text
                          ? node.featured_media.alt_text
                          : node.title
                      }
                    />
                  ) : (
                    <Img
                      fluid={data.placeholder.childImageSharp.fluid}
                      alt={node.title}
                    />
                  )}
                </div>
                <div className="text-part">
                  <span className="h5">{node.title}</span>
                  <div
                    className="excerpt"
                    dangerouslySetInnerHTML={{
                      __html: node.excerpt.slice(0, 250) + "...",
                    }}
                  />
                  {node?.tags && (
                    <div className="tags">
                      <p>
                        <span>Tagged:</span>{" "}
                        {node.tags.map((item, index) => {
                          return (
                            <>
                              <button
                                key={index + Math.random() * 100}
                                onClick={e => handleClick(e, item.path)}
                                className="tag"
                              >
                                {item.name}
                              </button>
                              {node.tags.length !== index + 1 && <>, </>}
                            </>
                          )
                        })}
                      </p>
                    </div>
                  )}
                  <span className="button transparent-button-gold">
                    อ่านเพิ่มเติม
                  </span>
                </div>
              </Link>
            )
          })}
        </PostContentWrapper>
        {pageCount > 1 && (
          <PaginationHolder>
            {index > 1 && (
              <div className="previousLink">
                <NavLink
                  test={first}
                  key={"link" + 1 + Math.random() * 100}
                  url={
                    index === 2
                      ? clearedPath
                      : currentCategory.path.replace("category/", "") +
                        previousUrl +
                        "/"
                  }
                  text="ก่อนหน้า"
                />
              </div>
            )}
            <div className="pageNumbers">
              {createPagination(pageCount, index)}
            </div>
            {index !== pageCount && (
              <div className="nextLink">
                <NavLink
                  test={last}
                  key={"link" + 1 + Math.random() * 100}
                  url={
                    currentCategory.path.replace("category/", "") +
                    nextUrl +
                    "/"
                  }
                  text="ถัดไป"
                />
              </div>
            )}
          </PaginationHolder>
        )}

        {currentCategory.description && (
          <ContentWrapper>
            <div
              dangerouslySetInnerHTML={{ __html: currentCategory.description }}
            />
          </ContentWrapper>
        )}

        <PromoBlock />
      </WrapperDesktop>

      <GameProvidersNew />
    </Layout>
  )
}
export default PaginatedPage

export const pageQuery = graphql`
  query($id: String) {
    allWordpressCategory(filter: { id: { eq: $id } }) {
      edges {
        node {
          id
          name
          slug
          description
          path
          link
          acf {
            category_image {
              alt_text
              localFile {
                childImageSharp {
                  fluid(maxWidth: 1400) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
          yoast_meta {
            yoast_wpseo_title
            yoast_wpseo_metadesc
          }
        }
      }
    }
    placeholder: file(relativePath: { eq: "placeholder.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`
